<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="color">mdi-water</v-icon>
      </template>
      <template #value>{{ humidity!=undefined ? humidity.toFixed(0) : '---' }}</template>
      <template #unit>{{ unit }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <HumidityChartDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" :reportInterval="reportInterval" :unit="unit" @setting="showSettingsDialog"></HumidityChartDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import HumidityChartDialog from '@/components/chart/HumidityChartDialog'

export default {
  name: 'HumidityTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    HumidityChartDialog
  },
  computed: {
    reportInterval() {
      return this.info.configurations.reportInterval;
    },
    humidity() {
      return this.report.humidity;
    },
    unit() {
      let u = this.info.configurations.reportUnit;
      if (u)
        return this.$t(`unit.${u}`);
      else
        return '';
    },
    color() {
      return this.humidity != undefined ? 'primary' : 'color';
    }
  }
}
</script>
